'use strict';

function EMTRequestAmount() {
  this.id = null;
  this.node = null;
  this.extends = [EMTController, _Paths];
  this._analytics = new Analytics();
  this._history = new History();

  this.classes = {
    form: '.js--form',
    submitBtn: '.js--submit',
    amountInput: '.js--amount',
    productInput: '.js--product'
  };

  this.init = function () {
    // needs to trigger before _super so can be applied to schemaValidation before scanDOM runs for cached schema
    this._setCustomValidations();
    this._super();

    this._form = document.querySelector(this.classes.form);
    this._submitBtn = document.querySelector(this.classes.submitBtn);
    this._amountField = document.querySelector(this.classes.amountInput);
    this._productField = document.querySelector(this.classes.productInput);

    this._setProductOnForm();
    this._createComponents();
    this._setupFormValidation();
    this._setupEventHandlers();
    this._setupComputedVariables();

    this.node.style.display = 'block';
  };

  this._setupFormValidation = function () {
    if (this.presenter.hasAction('account.create_emt_request')) {
      this._validateFormCallback = this.presenter.addCallbackToAction('account.create_emt_request', this._onValidateForm.bind(this));
    }
  };

  this._createComponents = function () {
    this._tooltip = $('.js--rate-tooltip').mogo().create('ToolTip', {
      targetElementId: 'available-crypto-tooltip',
      center: true,
      hover: true,
      closeIcon: false
    });
  };

  this._setupComputedVariables = function () {
    this.presenter.addComputedVariable('expectedBalance', ['cryptoHoldings.CAD.available'], function (val) {
      var inputAmount = this._amountField.mogo().val();
      var total = Number(inputAmount) + val;
      return '' + total;
    }.bind(this));
  };

  // Dynamically updates binded values
  this._setupEventHandlers = function () {
    this._amountField.addEventListener('keyup', function (e) {
      this._submitBtn.mogo().removeDisabledState();
      this.presenter.updateDOM(this.form);
    }.bind(this));
  };

  this._setProductOnForm = function () {
    this._productField.value = this.emtRequestProduct;
  };

  this._setCustomValidations = function () {
    this.presenter.extendCustomValidations('account.create_emt_request', {
      _hooks: { posthook: this._checkLoadAmount.bind(this) }
    });
  };

  this._checkLoadAmount = function () {
    var amountSchema = this._form.mogo().schema.properties.amount;
    var maxAmount = amountSchema.maximum;
    var minAmount = amountSchema.minimum;
    var amount = this._amountField.mogo().val();

    if (amount < minAmount) {
      this._amountField.mogo().showError();
      this._amountField.mogo().showErrorLabel(true, 'Hold up! The minimum amount you can fund is $' + minAmount + ' CAD.');
    } else if (amount > maxAmount) {
      this._amountField.mogo().showError();
      this._amountField.mogo().showErrorLabel(true, 'Hey big spender! The maximum amount you can fund is $' + maxAmount + ' CAD.');
    }
  };

  this._onValidateForm = function (data, response) {
    var _this = this;

    this._submitBtn.mogo().setDisabledState();

    if (this._form.mogo()._resultObj.count !== 0) {
      return;
    }

    // Creating EMT process can be lengthy
    //  Set load state with spinner when input has no errors
    this._submitBtn.mogo().setDisabledLoadState();

    var payLoad = $(this._form).serializeFormToObj();
    var amount = payLoad.amount;


    this.getEmtVelocity(function () {
      // Manually check for velocity limit, saves a call to the BE, this is an A/C for this feature
      if (!_this.isWithinVelocityLimit(amount)) {
        var errorMessage = 'The funding amount exceeds the 24 hour maximum limit. Please enter an amount within the range.';

        _this._amountField.mogo().showError();
        _this._amountField.mogo().showErrorLabel(true, errorMessage);
        // Analytics
        _this._analytics.forcePushEvent('generic-event', {
          category: ['MogoCrypto'],
          action: ['instant interac amount error'],
          label: [errorMessage.toLowerCase()]
        });
        _this._submitBtn.mogo().removeDisabledLoadState();
      } else if (data && !data.errors && !data.currentError) {
        _this.createEmtRequest(payLoad, _this._onCreateEmtRequestCallback.bind(_this));
      }
    });
  };

  this._onCreateEmtRequestCallback = function (data, response) {
    // Cache Latest Emt Request for request_id, to be used in iframe and status view
    this._saveLatestEmtRequest(data);
    // Don't need to rely on response code , rely on status instead;
    this._routeToNextStep(data.status);
  };

  this._routeToNextStep = function (status) {
    var url = '';
    switch (status) {
      case 'CUSTOMER_DISABLED':
      case 'LIMIT_EXCEEDED':
        url = this.paths.emt[this.emtRequestProduct].status;
        break;
      default:
        url = this.paths.emt[this.emtRequestProduct].request; // Iframe
    }

    return this._history.goToUrl(url);
  };

  this.destroy = function () {
    if (this._validateFormCallback) {
      this.presenter.removeCallbackFromAction('account.create_emt_request', this._validateFormCallback);
    }
    this.presenter.removeComputedVariable('expectedBalance');
  };
}